import { render, staticRenderFns } from "./chateau-de-camensac.vue?vue&type=template&id=03e36234&scoped=true"
import script from "./chateau-de-camensac.vue?vue&type=script&lang=js"
export * from "./chateau-de-camensac.vue?vue&type=script&lang=js"
import style0 from "./chateau-de-camensac.vue?vue&type=style&index=0&id=03e36234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e36234",
  null
  
)

export default component.exports